export const HOME = '/';
export const SIGN_IN = '/signin';
export const PREVIEW = '/preview';
